import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import { setLoading, saveData } from './actions';
import Permissions from './component';

class PermissionsContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // fetch all the permissions
    this.props.setLoading(true);
    this.props.getDataFromAPI(
      '/permissions/all?createdBy=1',
      'GET',
      undefined,
      (response) => {
        this.props.saveData(response);
        this.props.setLoading(false);
      },
      (err) => {
        this.props.setLoading(false);
        toastr.error('ERROR', err);
        console.log(err);
      }
    );
  }

  render() {
    const permissionData =
      this.props.permissions &&
      this.props.permissions.permissionData &&
      this.props.permissions.permissionData.list;
    const loading = this.props.permissions && this.props.permissions.loading;
    return <Permissions loading={loading} permissionData={permissionData} />;
  }
}

function mapStateToProps({ permissions }) {
  return {
    permissions
  };
}

export default withRouter(connect(mapStateToProps, {
  getDataFromAPI,
  setLoading,
  saveData
})(PermissionsContainer));



// WEBPACK FOOTER //
// ./src/Modules/Permissions/container.jsx